import { useSuspensionInfoFacade } from './useSuspensionInfoFacade';
import { useBillingAccount, usePlanGroup } from '../queries';

/**
 * Whether the user's own plan group is a legacy (non-3PL) group: v17-v20 and their price-increase
 * variants, whose plan types (GOOD/BETTER/BEST/LITE/GROWTH) the new payflow cannot render.
 * Derived from the group's plan types rather than a hardcoded list of plan group IDs.
 *
 * Uses the same query as usePlanGroupFacade without an override, so the flag and the plan group
 * resolve in the same render: once the group is known the 3PL override is applied immediately
 * and widgets never see the legacy group's plans.
 */
export const useIsLegacyPlanGroup = () => {
  const billingAccountQuery = useBillingAccount();
  const preSuspendPlanGroupId = useSuspensionInfoFacade().data?.getPreSuspendPlanGroupId();
  const { data } = usePlanGroup(billingAccountQuery.data?.getCurrency(), 0, undefined, preSuspendPlanGroupId);

  const isLegacyPlanGroup = data ? !data.is3PLGroup() : undefined;

  return {
    isLegacyPlanGroup,
    // useIs3PLCustomer is always false for legacy groups (it requires is3PLGroup()), so this is the
    // customer signal for them: a legacy group whose account is a paying customer (or suspended).
    isLegacyCustomer: data ? isLegacyPlanGroup && data.isCustomer() : undefined,
  };
};
